import { useEffect, useRef } from 'react';
import clsx from 'clsx';

export function FileInput({ label, accept, error, hint, value, onChange }) {
  const ref = useRef(null);
  // Controlled by `value`: the displayed name follows the prop, so a parent
  // reset (e.g. reopening the dialog) clears it immediately.
  const name = (value && value.name) || '';

  // The native file input keeps its selection even when `value` is cleared, so
  // wipe it whenever the value goes empty. This lets the operator re-pick the
  // same file and stops a stale filename from lingering across opens.
  useEffect(() => {
    if (!value && ref.current) ref.current.value = '';
  }, [value]);

  const onFile = (file) => {
    onChange(file || null);
  };

  return (
    <div className="flex flex-col gap-1.5">
      {label && <span className="text-sm font-medium text-ink">{label}</span>}
      <div
        className={clsx(
          'flex items-center gap-2 rounded-md border bg-surface-elevated px-2 py-1.5',
          error ? 'border-danger' : 'border-border'
        )}
      >
        <button
          type="button"
          className="rounded-md bg-ink px-3 py-1 text-xs font-medium text-white hover:bg-ink-muted"
          onClick={() => ref.current && ref.current.click()}
        >
          Scegli file
        </button>
        <span className="truncate text-xs text-ink-muted">{name || 'Nessun file selezionato'}</span>
        <input
          ref={ref}
          type="file"
          accept={accept}
          className="hidden"
          onChange={(e) => onFile(e.target.files && e.target.files[0])}
        />
      </div>
      {error ? <span className="text-xs text-danger">{error}</span> : hint ? <span className="text-xs text-ink-muted">{hint}</span> : null}
    </div>
  );
}
